export const COMMON_FEATURE_FLAGS = {
  DISABLE_AUTHORIZATION: "DISABLE_AUTHORIZATION",
} as const;
